import { render } from "./SearchEmployersList.vue?vue&type=template&id=48d02b98&ts=true"
import script from "./SearchEmployersList.vue?vue&type=script&lang=ts"
export * from "./SearchEmployersList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__